









































































import { BaseModule } from "@/store/base.module";
import { DalModule } from "@/store/dal.module";
import { Component, Vue } from "vue-property-decorator";
import { Account } from "~/dal/account";

@Component({})
export default class MainView extends Vue {
  dialog: boolean = false;
  loading: boolean = false;
  deleted: Account = null as any;
  dialogText: string = null as any;
  async deleteAcc() {
    try {
      BaseModule.setLoadingStatus(true);
      await DalModule.deleteAccount({ AccountId: this.deleted.account_id });
      await DalModule.getAccounts();
      if (DalModule.accounts && DalModule.accounts.length > 0) {
        DalModule.setAccountId(DalModule.accounts[0].account_id);
      }
    } finally {
      this.dialog = false;
      BaseModule.setLoadingStatus(false);
    }
  }
  get accounts() {
    return DalModule.accounts;
  }
  showDeleteDialog(item: Account) {
    this.deleted = item;
    this.dialogText = this.$t("account-info.delete", {
      account: item.account_id,
    }).toString();
    this.dialog = true;
  }
  async clickAcc(account_id: number) {
    //DalModule.setAccountId(account_id);
    this.$router.push({
      name: "account-info",
      params: { id: account_id.toString() },
    });
  }
}
